module.exports = __webpack_public_path__ + "static/media/upload.03f24274.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/views/docs/img/mocks/upload.png
// module id = 980
// module chunks = 0